import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useTenant } from './TenantContext';

const StandardContext = createContext();

export const useStandard = () => {
  const context = useContext(StandardContext);
  if (!context) {
    throw new Error('useStandard must be used within StandardProvider');
  }
  return context;
};

const STORAGE_KEY = 'preferredStandard';

export const StandardProvider = ({ children }) => {
  const { organization } = useTenant();
  const [availableStandards, setAvailableStandards] = useState([]);
  const [selectedStandard, setSelectedStandard] = useState(null);

  useEffect(() => {
    if (organization?.settings?.standards?.length) {
      const standards = organization.settings.standards;
      setAvailableStandards(standards);

      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && standards.includes(stored)) {
        setSelectedStandard(stored);
      } else {
        setSelectedStandard(standards[0]);
      }
    } else {
      setAvailableStandards([]);
      setSelectedStandard(null);
    }
  }, [organization]);

  const updateSelectedStandard = (standard) => {
    setSelectedStandard(standard);
    if (standard) {
      localStorage.setItem(STORAGE_KEY, standard);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  const value = useMemo(
    () => ({
      availableStandards,
      selectedStandard,
      setSelectedStandard: updateSelectedStandard
    }),
    [availableStandards, selectedStandard]
  );

  return <StandardContext.Provider value={value}>{children}</StandardContext.Provider>;
};

StandardProvider.propTypes = {
  children: PropTypes.node.isRequired
};




